const e = "_loader_1e45x_7", s = "_spinner_1e45x_10", _ = "_rotate_1e45x_1", l = "_dash_1e45x_1", i = "_ellipsis_1e45x_58", n = "_skeleton_1e45x_100", t = "_pulse_1e45x_1", o = {
  loader: e,
  spinner: s,
  rotate: _,
  dash: l,
  "size-md": "_size-md_1e45x_36",
  "size-lg": "_size-lg_1e45x_40",
  ellipsis: i,
  skeleton: n,
  "fade-in": "_fade-in_1e45x_1",
  pulse: t,
  "radius-full": "_radius-full_1e45x_123",
  "radius-lg": "_radius-lg_1e45x_127",
  "push-in": "_push-in_1e45x_1"
};
export {
  l as dash,
  o as default,
  i as ellipsis,
  e as loader,
  t as pulse,
  _ as rotate,
  n as skeleton,
  s as spinner
};
//# sourceMappingURL=loader.module.less.js.map
